<template>
  <div class="myloding">
    <div class="loadEffect">
      <div>
        <span></span>
      </div>
      <div>
        <span></span>
      </div>
      <div>
        <span></span>
      </div>
      <div>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { getWxOpenId, getUserInfoByWxOpenId } from "@/api/wxAndQywxLogin.js";
import {ipURL,baseURL} from '@/config/net.config'
export default {
  name: "wxloding",
  data() {
    return {
      wxOpenId: "",
      loading: true
    };
  },
  async mounted() {
    let code = this.getQueryString("code");
    console.log(code);
    if (!this.isEmpty(code)) {
      this.judgeOpenIdType(code);
    }
  },
  methods: {
    async judgeOpenIdType(code) {
      this.wxOpenId = await getWxOpenId(code);
      console.log("wxopenId===", this.wxOpenId);
      let userInfo = await getUserInfoByWxOpenId(this.wxOpenId);
      console.log("userInfo====", userInfo);
      if (
        !this.isEmpty(userInfo.data.userId) &&
        !this.isEmpty(userInfo.data.password)
      ) {
        window.location.href =
        ipURL+"/cas/login?service="+baseURL+"/index&userId=" +
          userInfo.data.userId +
          "&password=" +
          userInfo.data.password +
          "&type=1";
      } else {
        this.$router.push({
          name: "register",
          params: { wxOpenId: this.wxOpenId }
        });
      }
    },
    getQueryString(name) {
      var reg = new RegExp(
        "(^|&)" + encodeURIComponent(name) + "=([^&]*)(&|$)",
        "i"
      );
      var r = window.location.search.substr(1).match(reg);
      if (r !== null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    isEmpty(str) {
      if (str === undefined || str === "" || str === null) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
/*加载效果*/
.myloding {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.loadEffect {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  margin-top: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loadEffect div {
  width: 100%;
  height: 100%;
  position: absolute;
  animation: load 2.08s linear infinite;
}

.loadEffect div span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: lightgreen;
  position: absolute;
  left: 50%;
  margin-top: -10px;
  margin-left: -10px;
}

@keyframes load {
  0% {
    -webkit-transform: rotate(0deg);
  }
  10% {
    -webkit-transform: rotate(45deg);
  }
  50% {
    opacity: 1;
    -webkit-transform: rotate(160deg);
  }
  62% {
    opacity: 0;
  }
  65% {
    opacity: 0;
    -webkit-transform: rotate(200deg);
  }
  90% {
    -webkit-transform: rotate(340deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.loadEffect div:nth-child(1) {
  animation-delay: 0.2s;
}

.loadEffect div:nth-child(2) {
  animation-delay: 0.4s;
}

.loadEffect div:nth-child(3) {
  animation-delay: 0.6s;
}

.loadEffect div:nth-child(4) {
  animation-delay: 0.8s;
}
</style>